module.exports = __webpack_public_path__ + "static/media/152-kyrgyzstan.96679340.svg";